function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import { useState } from "react";
import { calculateFocusTarget } from "./helpers/calculateFocusTarget.js";
import { getNextFocus } from "./helpers/getNextFocus.js";
/** @private */
export function useFocus(props, calendar, getModifiers, isSelected, dateLib) {
  var autoFocus = props.autoFocus;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    lastFocused = _useState2[0],
    setLastFocused = _useState2[1];
  var focusTarget = calculateFocusTarget(calendar.days, getModifiers, isSelected || function () {
    return false;
  }, lastFocused);
  var _useState3 = useState(autoFocus ? focusTarget : undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    focusedDay = _useState4[0],
    setFocused = _useState4[1];
  var blur = function blur() {
    setLastFocused(focusedDay);
    setFocused(undefined);
  };
  var moveFocus = function moveFocus(moveBy, moveDir) {
    if (!focusedDay) return;
    var nextFocus = getNextFocus(moveBy, moveDir, focusedDay, calendar.navStart, calendar.navEnd, props, dateLib);
    if (!nextFocus) return;
    calendar.goToDay(nextFocus);
    setFocused(nextFocus);
  };
  var isFocusTarget = function isFocusTarget(day) {
    return Boolean(focusTarget === null || focusTarget === void 0 ? void 0 : focusTarget.isEqualTo(day));
  };
  var useFocus = {
    isFocusTarget: isFocusTarget,
    setFocused: setFocused,
    focused: focusedDay,
    blur: blur,
    moveFocus: moveFocus
  };
  return useFocus;
}